import type { ComponentLoaderType } from '@grafikr/components';

const Loader: ComponentLoaderType = ({ node }, load) => {
  const target = node.dataset.loadTarget;

  if (!target) {
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.error(node, 'Element needs a data-load-target attribute');
    }

    return () => {};
  }

  const targets = document.querySelectorAll<HTMLElement>(`[data-load="${target}"]`);
  const options = <AddEventListenerOptions>{
    passive: true,
    once: true,
  };

  const disconnectors: CallableFunction[] = [];

  targets.forEach((element) => {
    const event = element.dataset.event || 'click';

    element.addEventListener(event, load, options);

    disconnectors.push(() => {
      element.removeEventListener(event, load, options);
    });
  });

  return () => {
    disconnectors.forEach((disconnect) => {
      disconnect();
    });
  };
};

export default Loader;
